The identifier for the `HiringOrganization` that will own the questionnaire.

Hirers can only associate position profiles with questionnaires they own.
